import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { BoundedNameModel } from "../../models/BoundedNameModel";

export const EmailCycleNameModel = types.model("EmailCycleNameModel", {
  scheduleId: types.string,
  name: BoundedNameModel,
});

export const createEmailCycleNameModel = (
  emailCycleName: SnapshotIn<typeof EmailCycleNameModel>,
): Instance<typeof EmailCycleNameModel> =>
  EmailCycleNameModel.create(emailCycleName);
